import { useCallback } from "react";

import { useStayableDayOfTheWeek } from "@/components/features/items/edit/_shared/ui/components/main/questions/stayable-day-of-the-week/hooks/use-stayable-day-of-the-week";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanStayableDayOfTheWeek = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { stayableDayOfTheWeek } = viewModel;

	const isHolidayStayable = viewModel.isHolidayStayable?.value ?? undefined;

	const onSetIsHolidayStayable = useCallback(
		(value: boolean | undefined) => {
			onSetViewModel([
				{
					key: "isHolidayStayable",
					value: {
						isEdited: true,
						value: value ?? null,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		...useStayableDayOfTheWeek({
			stayableDayOfTheWeek,
			onSetViewModel,
		}),
		isHolidayStayable,
		onSetIsHolidayStayable,
	};
};
